import { ptWallToUtc } from '../../utils/timezone';

/**
 * Helpers shared by the parent submission form and the admin Pick form
 * (docs/prd-homepage-redesign.md §5.2, §6.3).
 */

const HAN = /\p{Script=Han}/u;

/** One free-text line goes to the Chinese or English column by its script. */
export function splitByScript(text: string): { cn: string | null; en: string | null } {
  const value = text.trim();
  if (!value) return { cn: null, en: null };
  return HAN.test(value) ? { cn: value, en: null } : { cn: null, en: value };
}

export interface DateRow {
  /** YYYY-MM-DD in California */
  date: string;
  /** HH:MM, 24-hour, California */
  start: string;
  end: string;
}

/** A California date and two times to UTC instants; null when incomplete or invalid. */
export function dateRowToOccurrence(row: DateRow): { startTime: string; endTime: string } | null {
  const d = row.date.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  const s = row.start.match(/^(\d{2}):(\d{2})$/);
  const e = row.end.match(/^(\d{2}):(\d{2})$/);
  if (!d || !s || !e) return null;
  const [y, m, day] = [Number(d[1]), Number(d[2]), Number(d[3])];
  const start = ptWallToUtc(y, m, day, Number(s[1]), Number(s[2]), 0, 0);
  const end = ptWallToUtc(y, m, day, Number(e[1]), Number(e[2]), 0, 0);
  return { startTime: start.toISOString(), endTime: end.toISOString() };
}
